import React, { useEffect } from 'react';
import './quests-landing.styles.scss';
import { useSelector } from 'react-redux';

const PlayerQuestsLanding = ({ gameData, playerData }) => {

  const userProfile = useSelector(state => state.userData.userProfile);

  useEffect(() => {

    return () => {

    }
  }, [])

  useEffect(() => {
    // getQuests();
    // getPlayerProgress();
  }, [userProfile]);

  function getQuests() {

  }

  return (
    <div className='player-quests-landing-container'>
      <div className='player-quests-landing-card g-card'>
        PlayerQuests  
      </div>
    </div>
  )
}

export default PlayerQuestsLanding